<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Adding contacts
                </h2>
                <p>
                    ToTok quickly and easily recognizes which of your contacts are using ToTok by accessing your phone's
                    Contacts.
                </p>
                <h3>
                    To add a ToTok contact from your phone’s Contacts
                </h3>
                <ol>
                    <li>
                        Save a contact's name and phone number in your phone's Contacts.
                    </li>
                    <li>
                        Open ToTok and go to the <strong>Chats</strong> tab.
                    </li>
                    <li>
                        Tap the “⊕” icon at the top right > <strong>Add Friends</strong> > <strong>Add from
                        Contacts</strong>.
                    </li>
                </ol>
                <h3>
                    To add a ToTok contact by scanning QR Code
                </h3>
                <ol>
                    <li>
                        Open ToTok and go to the <strong>Chats</strong> tab.
                    </li>
                    <li>
                        Tap the “⊕” icon at the top right > <strong>Add Friends</strong> > <strong>Scan to Add Friends</strong>.
                    </li>
                </ol>
                <h3>
                    To add a ToTok contact by searching number or ToTok ID
                </h3>
                <ol>
                    <li>
                        Open ToTok and go to the <strong>Chats</strong> tab.
                    </li>
                    <li>
                        Tap the “⊕” icon at the top right > <strong>Add Friends</strong>
                    </li>
                    <li>
                        Type international number with country/region code and phone number, or ToTok ID. Then tap
                        <strong>Go</strong>.
                    </li>
                    <li>
                        Then tap <strong>Add</strong>.
                    </li>
                </ol>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
